// import APIs
import { updateDutyLineFlags } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';
import { UpdateDutyLineFlagsParams } from './useUpdateDutyLineFlags.types';

const useUpdateDutyLineFlags = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: UpdateDutyLineFlagsParams) => updateDutyLineFlags(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useUpdateDutyLineFlags;
